// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__gxIbG","SponsoredBadge":"badge_SponsoredBadge__iIO5V"};